import APIService from "@/services/APIService.js"; 

export default {
  getModulos(versao) {
    return APIService.apiCall().get(`/modulosAneel/getModulos/${versao}`);
  },
  download(postData) {
    return APIService.apiCall().post(`/modulosAneel/exportarModulosCsv`, JSON.stringify(postData), { responseType: "blob", timeout: 60 * 60 * 1000 });
  },
  deletar(dataRegistro, moduloAtual) {
    return APIService.apiCall().get(`/modulosAneel/excluir/${dataRegistro}/${moduloAtual}`);
  },
  getModulosPreview(data, versao) {
    return APIService.apiCall().get(`/modulosAneel/getModulosPreview/${data}/${versao}`);
  },
  calcular() {
    return APIService.apiCall().get("/modulosAneel/calcular");
  }
}